import { render, staticRenderFns } from "./ProjectSchema.vue?vue&type=template&id=0251f61f&"
import script from "./ProjectSchema.vue?vue&type=script&lang=js&"
export * from "./ProjectSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports